import React from 'react';
import MUIDataTable from 'mui-datatables';
import { Localizacion } from 'lib.front';

const options = {
    filter: false,
    selectableRows: 'none',
    responsive: 'standard',
    expandableRowsHeader: false,
    pagination: true,
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15, 100],
    search: true,
    print: false,
    download: false,
    viewColumns: false,
    fixedHeader: false,
    selectToolbarPlacement: 'none',
    selectableRowsOnClick: true,
    textLabels: Localizacion.muiDataTables.ES
};


export const DataTable = ({ data, columns }) => {
    return (
        <MUIDataTable
            options={options}
            data={data}
            columns={columns}
        />
    )
}
